import Layout from "../../components/Layout";
import LogInForm  from "../../components/LogInForm";

import styles from "./log-in.module.scss"
import { useRouter } from 'next/router';
import { GetServerSideProps } from 'next'
import { MenuId } from "../../components/Header";
import {serialize} from 'cookie'
import { getWpCookieName } from "../../lib/wp-login";
import Head from 'next/head';
import { useAuth as useClerkAuth, useSignIn } from '@clerk/nextjs'
import { Alert, Title } from "@mantine/core";
import { sign } from "crypto";
import { getAuth, buildClerkProps } from "@clerk/nextjs/server";
import { useEffect, useState } from "react";
import useAuth
 from "../../lib/useAuth";


export default function LogIn<Props>() {


  const router = useRouter();
   const { isSignedIn, isLoaded   } = useClerkAuth();
   const [warning, setWarning] = useState<string | null>(null);
   
  const { redirect_to, email, __clerk_ticket} = router.query;
  const { signIn } = useSignIn();
  const {refreshUserInformation} = useAuth();
  
  let redirectUrl = '/my-account';

  if (typeof redirect_to === 'string')
  {
    redirectUrl = redirect_to as string;
  }

  useEffect(()=>{

    async function signInWithTicket(ticket: string)
    {
     
      const {error} =await signIn.create({strategy: 'ticket',ticket});

      if (error)
      {
        console.error("Error signing in with ticket", error);
        setWarning("There was an issue. Check the dev console for details.");
      }
      else
      {
        refreshUserInformation();
          router.push(redirectUrl ?? '/my-account');
      }
      
    }
    if (__clerk_ticket)
    {
      signInWithTicket(__clerk_ticket as string);
    }

  },[]);
    

  return (
  
    <Layout menuId={MenuId.account} hidePopUp>   
      <Head>
            <link rel='canonical' href={process.env.ROOT_PATH + '/log-in'} key="canonical"/>
    </Head>  

{warning && <Alert>{warning}  </Alert>}
    {(!isSignedIn) &&

<>
      <Title order={2} ta='center' mb='xs' mt='md'>Log In to Raw Umber</Title>
        <div className = {styles.login}>
        <LogInForm redirect={redirectUrl} defaultEmail={email as string}/>
        </div>
        </>
}

{(isSignedIn) &&
  <>
    <Title order={2} ta='center' mb='xs' mt='md'>You are already logged in.</Title>

    <Title order={3} ta='center' mb='xs'>Go here to view your <a href="/my-account">account details</a>.</Title>
    </>
} 
    </Layout>
  );
}


export const getServerSideProps : GetServerSideProps = async (context)=>
{
  
  const {action, redirect_to} = context.query;




  if (action=='logout')
  {   
   
    let cookie = serialize(await getWpCookieName(), '', {path:'/',  httpOnly:true, secure:true, maxAge:0});
    context.res.setHeader("Set-Cookie", cookie);

    let url = "/";

    if (redirect_to !== undefined && typeof redirect_to ==='string')
    {
        url = redirect_to as string;
    }

    return {
      redirect: 
      {
        destination: url,
        permanent: false
      }
    }

  }

    return { props: { ...buildClerkProps(context.req) } }


}

